import { render, staticRenderFns } from "./FilterChip.vue?vue&type=template&id=aaa5ab34&"
import script from "./FilterChip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FilterChip.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaa5ab34')) {
      api.createRecord('aaa5ab34', component.options)
    } else {
      api.reload('aaa5ab34', component.options)
    }
    module.hot.accept("./FilterChip.vue?vue&type=template&id=aaa5ab34&", function () {
      api.rerender('aaa5ab34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/memorial/MemoryBoardPage/components/DoctorFilter/FilterChip.vue"
export default component.exports